import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsExportCallHistory,
  type IParamsGetCallHistory,
  type IParamsGetCallHistoryStatistic,
  type IResponseCallHistory,
  type IResponseExportCallHistory,
  type IResponseGetCallHistoryStatistic,
} from 'entities/CallHistory/api/types'

class Api {
  getCallHistoryStatistic(
    params: IParamsGetCallHistoryStatistic,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetCallHistoryStatistic>> {
    return baseApi.get('call-history/statistics', { params, ...options })
  }

  getCallHistory(
    params: IParamsGetCallHistory,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseCallHistory>> {
    return baseApi.get('call-history', { params, ...options })
  }

  exportCallHistory(
    params: IParamsExportCallHistory
  ): Promise<AxiosResponse<IResponseExportCallHistory>> {
    return baseApi.get('call-history/export', { params })
  }
}

export const CallHistoryApi = new Api()
